exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2QeQoWKUVyau4Rj0JwjJZx{width:auto;width:200px}._2QeQoWKUVyau4Rj0JwjJZx:before{content:\"\";display:inline-block;float:right;height:15px;width:15px}\n", ""]);

// Exports
exports.locals = {
	"CuePopup": "_2QeQoWKUVyau4Rj0JwjJZx"
};